<template>
  <combo-tree-common v-bind="$props" v-on="$listeners" />
</template>
<script>
import comboMixin from '../mixins/combo.mixin'
export default {
  mixins: [ comboMixin ],
  name: 'ComboTreeCategory',
  props: {
    pathName: {
      type: String, default: '/goods/category/tree'
    },
    eventName: {
      type: String, default: 'refresh--comno-tree-category'
    }
  }
}
</script>
